import React from 'react';
import LoaderImage from '../img/mob_logo.png';
const TableLoader = ({colSpan}) => {
	return (
        <>
             <tbody className='loader_wrapper'>
                
                <tr>
                    <td colSpan={colSpan}>
                        <div className="loading_wrp">
                            <img src={LoaderImage} alt='isloading' width={30} height={50}/>
                        </div>
                    </td>
                </tr>
            </tbody>
       
        </>
	);
};

export default TableLoader;